import type { I18nUtilities } from '@change-corgi/core-react/i18n';

import type { ShareChannel as PageShareChannel } from '#src/app/pages/psf/promoteOrShare/shared/types';
import type { ShareAction } from '#src/app/shared/hooks/share';

type TranslateLabel = (i18n: I18nUtilities) => string;

const SHARE_BUTTON_CONFIG: Readonly<
	Record<PageShareChannel, { label: TranslateLabel; successLabel?: TranslateLabel; secondaryLabel?: TranslateLabel }>
> = {
	facebook: { label: (i18n) => i18n.translate('fe.components.psf.share.buttons.short.facebook') },
	facebookMessenger: { label: (i18n) => i18n.translate('fe.components.psf.share.buttons.short.facebook_messenger') },
	twitter: { label: (i18n) => i18n.translate('fe.components.psf.share.buttons.short.twitter') },
	whatsapp: { label: (i18n) => i18n.translate('fe.components.psf.share.buttons.short.whatsapp') },
	instagram: { label: (i18n) => i18n.translate('fe.components.psf.share.buttons.short.instagram') },
	line: { label: (i18n) => i18n.translate('fe.components.psf.share.buttons.short.line') },
	email: { label: (i18n) => i18n.translate('fe.components.psf.share.buttons.short.email') },
	sms: { label: (i18n) => i18n.translate('fe.components.psf.share.buttons.short.sms') },
	copy: {
		label: (i18n) => i18n.translate('fe.components.psf.share.buttons.copy_link'),
		successLabel: (i18n) => i18n.translate('fe.components.share_buttons.copied'),
		secondaryLabel: (i18n) => i18n.translate('corgi.psf.share.buttons.share_link_label'),
	},
	vk: { label: (i18n) => i18n.translate('fe.components.psf.share.buttons.short.vk') },
	nextdoor: { label: (i18n) => i18n.translate('corgi.psf.share.buttons.short.nextdoor') },
	mobileNativeShare: { label: (i18n) => i18n.translate('corgi.psf.share.buttons.short.mobile_share') },
	reddit: { label: (i18n) => i18n.translate('corgi.psf.share.buttons.short.reddit') },
	instagramStories: { label: (i18n) => i18n.translate('fe.components.psf.share.buttons.short.instagram') },
	tiktok: { label: (i18n) => i18n.translate('corgi.psf.share.buttons.short.tiktok') },
};

type Result = ReadonlyArray<{
	ShareAction: ShareAction['ShareAction'];
	channel: PageShareChannel;
	label: TranslateLabel;
	successLabel?: TranslateLabel;
	secondaryLabel?: TranslateLabel;
	url: string;
	shortUrl?: string;
}>;

function isPageShareAction(action: ShareAction): action is ShareAction {
	return action.channel in SHARE_BUTTON_CONFIG;
}

export function mapButtonConfigs(shareActions: readonly ShareAction[]): Result {
	return shareActions.filter(isPageShareAction).map(({ ShareAction, channel, url, shortUrl }) => ({
		ShareAction,
		channel,
		url,
		shortUrl,
		...SHARE_BUTTON_CONFIG[channel],
	}));
}
